module.exports = __webpack_public_path__ + "img/BasePage.833bc7c0.png";